<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
const defaultLayout = "default";
export default {
  data() {
    return {

    };
  },
  computed:{
    layout(){
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  },
  created(){
    this.path = this.$router.history.current.fullPath;
  },


  
};

</script>
